import React, { useEffect, useState } from 'react';

import { TEMPLATES_GALLERY_ENTRY } from '@utils/constants';
import { templatesPath } from './useRouter';
import {
  getDataCapsule,
  RECOMMENDED_TEMPLATE_ENTRY_KEY,
} from '@components/Template/RecommendedTemplates/data-capsule-adaptor';

let cachedEntry: string | null | undefined;

export const resetCachedEntry = () => {
  cachedEntry = undefined;
};

export const useTemplateEntry = () => {
  const [entry, setEntry] = useState<string | null | undefined>(cachedEntry);

  useEffect(() => {
    if (cachedEntry !== undefined) {
      setEntry(cachedEntry);
      return;
    }

    let cancelled = false;
    const referrer = document?.referrer;
    const urlParams = new URL(window.location.href).searchParams;

    const isFromTemplatesGallery = referrer?.includes(templatesPath);
    const entryFromUrl = urlParams.get('entry');

    if (isFromTemplatesGallery) {
      cachedEntry = TEMPLATES_GALLERY_ENTRY;
      setEntry(TEMPLATES_GALLERY_ENTRY);
      return;
    }

    if (entryFromUrl) {
      cachedEntry = entryFromUrl;
      setEntry(entryFromUrl);
      return;
    }

    (async () => {
      try {
        const capsule = getDataCapsule();
        const storedEntry = await capsule.getItem(
          RECOMMENDED_TEMPLATE_ENTRY_KEY,
        );
        if (storedEntry) {
          cachedEntry = storedEntry as string;
          if (!cancelled) setEntry(storedEntry as string);
          await capsule.removeItem(RECOMMENDED_TEMPLATE_ENTRY_KEY);
          return;
        }
      } catch {
        // storage unavailable
      }
      cachedEntry = null;
      if (!cancelled) setEntry(null);
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    entry,
  };
};
